export const STALE_BUILD_HISTORY_THRESHOLD_DAYS = 3

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000

export function daysSinceLatestBuild(latestBuildTimestamp: Date, now: Date): number {
  return (now.getTime() - latestBuildTimestamp.getTime()) / MILLISECONDS_PER_DAY
}

export function isBuildHistoryStale(
  latestBuildTimestamp: Date | null,
  now: Date,
  thresholdDays: number = STALE_BUILD_HISTORY_THRESHOLD_DAYS
): boolean {
  if (!latestBuildTimestamp) return false
  return daysSinceLatestBuild(latestBuildTimestamp, now) > thresholdDays
}
